import { z } from 'zod';

/**
 * Append-only version history for `restaurantUsers.notes`.
 *
 * Why this table exists: the AI agent edits CRM notes about restaurant users,
 * so we keep a snapshot on every save to monitor how the agent changes the
 * notes over time and revert if it goes off the rails. Mirrors the
 * `menuVersionSchema` pattern - narrower, since we only version `notes`.
 */
export const restaurantUserNoteVersionSchema = z.object({
  restaurantUserId: z.string(),
  notes: z.string(),

  _creationTime: z.number().optional(),
  _id: z.string().optional(),
});
export type RestaurantUserNoteVersion = z.output<typeof restaurantUserNoteVersionSchema>;

export const restaurantUserNoteVersionStrictSchema = restaurantUserNoteVersionSchema.safeExtend({});

export const restaurantUserNoteVersionCvxSchema = restaurantUserNoteVersionSchema.safeExtend({
  _creationTime: z.number(),
  _id: z.string(),
});
export type RestaurantUserNoteVersionCvx = z.output<typeof restaurantUserNoteVersionCvxSchema>;
